import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: 'General',
      pages: [
        {
          title: i18n.t('pages.dashboard'),
          to: { name: 'Index' },
          icon: 'ballot',
          exact: true,
        },
        {
          title: i18n.t('pages.twenty'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
          exact: false,
        },
      ],
    },
    {
      subheading: 'Payments',
      pages: [
        {
          title: i18n.t('pages.supplierPayments'),
          to: { name: 'SupplierPayments' },
          icon: 'storefront',
          exact: false,
        },
        {
          title: i18n.t('pages.clientPayments'),
          to: { name: 'ClientPayments' },
          icon: 'wc',
          exact: false,
        },
      ],
    },
    {
      subheading: 'Gift Vouchers',
      pages: [
        {
          title: i18n.t('menu.giftVouchers.pages.search.title'),
          to: { name: i18n.t('menu.giftVouchers.pages.search.title') },
          icon: 'storefront',
          exact: false,
        },
      ],
    },
  ],
  breadcrumbs: undefined,
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js